module.exports = __webpack_public_path__ + "img/sup_login_banner.86244058.png";